import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { Meeting, MeetingTypeEnum } from 'lingo2-models';
import { FormatPipeModule } from 'lingo2-ngx-date-fns';
import { OnUiButtonModule } from 'onclass-ui';

@Component({
  selector: 'app-meeting-mini-card',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiButtonModule, FormatPipeModule],
  templateUrl: './meeting-mini-card.component.html',
  styleUrls: ['./meeting-mini-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingMiniCardComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() public set meeting(meeting: Meeting) {
    this._meeting = meeting;
    this.init();
  }
  public get meeting(): Meeting {
    return this._meeting;
  }
  @Output() openCard = new EventEmitter();

  private _meeting: Meeting;

  public coverImgUrl: string;
  public subject: string;
  public title: string;
  public type: string;
  public group: string;
  public meetingDate: Date;
  public price: number;

  ngOnInit() {}

  public init() {
    this.coverImgUrl = this._meeting.cover && this._meeting.cover.md ? this._meeting.cover.md.url : null;
    this.title = this._meeting.title;
    this.subject = this._meeting.subject ? this._meeting.subject.title : null;
    this.meetingDate = new Date(this._meeting.begin_at);
    this.group = `${this._meeting.participants_count} / ${this._meeting.participants_limit}`;
    this.type = MeetingTypeEnum[this._meeting.type];
    this.price = this._meeting.price_tier ? this._meeting.price_tier : null;
  }

  public openModal(e) {
    this.openCard.emit(e);
  }
}
